import {useEffect, useRef} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import './MultiChart.scss';

am4core.addLicense('CH332271218');

am4core.useTheme(am4themes_animated);

const MultiChart = ({chartData, title, chartId}: any) => {
  const trendChartRef: any = useRef(null);
  const seasonalityChartRef: any = useRef(null);
  const residualChartRef: any = useRef(null);

  useEffect(() => {

    // Trend Chart
    trendChartRef.current = am4core.create(`${chartId}-trend`, am4charts.XYChart);
    const trendChartTitle = trendChartRef.current.titles.create();
    trendChartTitle.text = `${title} - Trend`
    trendChartTitle.marginBottom = 10;

    trendChartRef.current.data = chartData;
    trendChartRef.current.dateFormatter.inputDateFormat = 'MM-dd-yyyy';

    const trendDateAxis = trendChartRef.current.xAxes.push(new am4charts.DateAxis());
    trendDateAxis.renderer.grid.template.strokeWidth = 1;
    trendDateAxis.renderer.grid.template.strokeOpacity = 0.3;
    trendDateAxis.renderer.grid.template.stroke = '#fff';
    trendDateAxis.renderer.minGridDistance = 40;
    trendDateAxis.renderer.labels.template.fontSize = 10;
    trendDateAxis.title.fontWeight = 'bold';
    trendDateAxis.dateFormats.setKey('month', 'MMM YY');
    trendDateAxis.renderer.labels.template.fill = '#fff';

    const trendValueAxis = trendChartRef.current.yAxes.push(new am4charts.ValueAxis());
    trendValueAxis.renderer.grid.template.stroke = '#fff';
    trendValueAxis.renderer.grid.template.strokeWidth = 1;
    trendValueAxis.renderer.grid.template.strokeOpacity = 0.3;
    trendValueAxis.title.fontWeight = 'bold';
    trendValueAxis.renderer.labels.template.fontSize = 10;
    trendValueAxis.renderer.labels.template.fill = '#fff';

    const trendSeries = trendChartRef.current.series.push(new am4charts.LineSeries());
    trendSeries.dataFields.dateX = 'date';
    trendSeries.dataFields.valueY = 'trend'
    trendSeries.strokeWidth = 2;
    trendSeries.name = 'Actual Prediction';
    trendSeries.tooltipText = "Trend Value: {valueY}";
    trendSeries.stroke = '#f7b047';
    trendSeries.fill = '#f7b047';



    trendChartRef.current.cursor = new am4charts.XYCursor();
    trendChartRef.current.cursor.xAxis = trendDateAxis;

    // Seasonality Chart
    seasonalityChartRef.current = am4core.create(`${chartId}-seasonality`, am4charts.XYChart);
    const seasonalityChartTitle = seasonalityChartRef.current.titles.create();
    seasonalityChartTitle.text = `${title} - Seasonality`
    seasonalityChartTitle.marginBottom = 10;

    seasonalityChartRef.current.data = chartData;
    seasonalityChartRef.current.dateFormatter.inputDateFormat = 'yyyy-MM-dd';

    const seasonalityDateAxis = seasonalityChartRef.current.xAxes.push(new am4charts.DateAxis());
    seasonalityDateAxis.renderer.grid.template.strokeWidth = 1;
    seasonalityDateAxis.renderer.grid.template.strokeOpacity = 0.3;
    seasonalityDateAxis.renderer.grid.template.stroke = '#fff';
    seasonalityDateAxis.renderer.minGridDistance = 40;
    seasonalityDateAxis.renderer.labels.template.fontSize = 10;
    seasonalityDateAxis.title.fontWeight = 'bold';
    seasonalityDateAxis.dateFormats.setKey('month', 'MMM YY');
    seasonalityDateAxis.renderer.labels.template.fill = '#fff';

    const seasonalityValueAxis = seasonalityChartRef.current.yAxes.push(new am4charts.ValueAxis());
    seasonalityValueAxis.renderer.grid.template.stroke = '#fff';
    seasonalityValueAxis.renderer.grid.template.strokeWidth = 1;
    seasonalityValueAxis.renderer.grid.template.strokeOpacity = 0.3;
    seasonalityValueAxis.title.fontWeight = 'bold';
    seasonalityValueAxis.renderer.labels.template.fontSize = 10;
    seasonalityValueAxis.renderer.labels.template.fill = '#fff';

    const seasonalitySeries = seasonalityChartRef.current.series.push(new am4charts.LineSeries());
    seasonalitySeries.dataFields.dateX = 'date';
    seasonalitySeries.dataFields.valueY = 'seasonality'
    seasonalitySeries.strokeWidth = 2;
    seasonalitySeries.name = 'Actual Prediction';
    seasonalitySeries.tooltipText = "Seasonality Value: {valueY}";
    seasonalitySeries.stroke = '#f7b047';
    seasonalitySeries.fill = '#f7b047';


    seasonalityChartRef.current.cursor = new am4charts.XYCursor();
    seasonalityChartRef.current.cursor.xAxis = seasonalityDateAxis;


    // Residual Chart
    residualChartRef.current = am4core.create(`${chartId}-residual`, am4charts.XYChart);
    const residualChartTitle = residualChartRef.current.titles.create();
    residualChartTitle.text = `${title} - Residual`
    residualChartTitle.marginBottom = 10;

    residualChartRef.current.data = chartData;
    residualChartRef.current.dateFormatter.inputDateFormat = 'yyyy-MM-dd';

    const residualDateAxis = residualChartRef.current.xAxes.push(new am4charts.DateAxis());
    residualDateAxis.renderer.grid.template.strokeWidth = 1;
    residualDateAxis.renderer.grid.template.strokeOpacity = 0.3;
    residualDateAxis.renderer.grid.template.stroke = '#fff';
    residualDateAxis.renderer.minGridDistance = 40;
    residualDateAxis.renderer.labels.template.fontSize = 10;
    residualDateAxis.title.fontWeight = 'bold';
    residualDateAxis.dateFormats.setKey('month', 'MMM YY');
    residualDateAxis.renderer.labels.template.fill = '#fff';

    const residualValueAxis = residualChartRef.current.yAxes.push(new am4charts.ValueAxis());
    residualValueAxis.renderer.grid.template.stroke = '#fff';
    residualValueAxis.renderer.grid.template.strokeWidth = 1;
    residualValueAxis.renderer.grid.template.strokeOpacity = 0.3;
    residualValueAxis.title.fontWeight = 'bold';
    residualValueAxis.renderer.labels.template.fontSize = 10;
    residualValueAxis.renderer.labels.template.fill = '#fff';

    const residualSeries = residualChartRef.current.series.push(new am4charts.LineSeries());
    residualSeries.dataFields.dateX = 'date';
    residualSeries.dataFields.valueY = 'residual'
    residualSeries.strokeWidth = 2;
    residualSeries.name = 'Actual Prediction';
    residualSeries.tooltipText = "Residual Value: {valueY}";
    residualSeries.stroke = '#f7b047';
    residualSeries.fill = '#f7b047';


    residualChartRef.current.cursor = new am4charts.XYCursor();
    residualChartRef.current.cursor.xAxis = seasonalityDateAxis;

    return () => {
      trendChartRef.current && trendChartRef.current.dispose();
      trendChartRef.current && seasonalityChartRef.current.dispose();
      residualChartRef.current && residualChartRef.current.dispose();
    };
  }, [chartData, chartId]);

  return (
    <div className='what-if-chart'>
      <div className='multi-chart-area' >
        <div className='chart-multi' id={`${chartId}-trend`} ref={trendChartRef} />
        <div className='chart-multi' id={`${chartId}-seasonality`} ref={seasonalityChartRef}/>
        <div className='chart-multi' id={`${chartId}-residual`} ref={residualChartRef}/>
      </div>
    </div>
  );
};

export default MultiChart;
